import Avatar from "@mui/material/Avatar";
import Badge from "@mui/material/Badge";
import React, { useState, useEffect, useContext } from "react";
import { styled } from "@mui/material/styles";
import { stringAvatar } from "../helper/GeneralHelper";
import Skeleton from "@mui/material/Skeleton";
import { SocketContext } from "../../context/SocketContext";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const DefaultAvatar = ({
  online: onlineProp,
  id,
  loading,
  width,
  height,
  className,
  children,
  marginBottom,
  top,
  left,
  userName,
  onClick,
  fontSize,
  marginRight,
  editor,
}) => {
  const socketContext = useContext(SocketContext);
  const [online, setOnline] = useState(onlineProp ? onlineProp : false);

  useEffect(() => {
    if (window.location.pathname.includes("chats")) {
      socketContext?.socket?.on("get_online_user", (user) => {
        if (id === user?.userId) {
          setOnline(true);
        }
      });
      socketContext?.socket?.on("get_offline_user", (user) => {
        if (id === user?.userId) {
          setOnline(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span className="default-avatar-bg">
      {loading ? (
        <Skeleton
          sx={{ bgcolor: "grey.900" }}
          variant="circular"
          width={width}
          height={height}
          className={className}
        />
      ) : children ? (
        online ? (
          <StyledBadge
            className="defaultAvatarBadge"
            overlap="circular"
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            variant="dot"
            sx={{
              marginBottom: marginBottom,
              top: top,
              left: left,
            }}
          >
            {children}
          </StyledBadge>
        ) : (
          <StyledBadge
            className="defaultAvatarBadge"
            // overlap="circular"
            // anchorOrigin={{
            //   vertical: "bottom",
            //   horizontal: "right",
            // }}
            // variant="dot"
            sx={{
              marginBottom: marginBottom,
              top: top,
              left: left,
            }}
          >
            {children}
          </StyledBadge>
        )
      ) : online ? (
        <StyledBadge
          className="defaultAvatarBadge"
          overlap="circular"
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          variant="dot"
          sx={{
            marginBottom: marginBottom,
            top: top,
            left: left,
          }}
        >
          <Avatar
            onClick={onClick}
            alt={userName}
            title={userName}
            {...stringAvatar(userName)}
            className={className}
            sx={{
              height: height,
              width: width,
              backgroundColor: "black",
              fontSize: fontSize ? fontSize : "1rem",
            }}
          ></Avatar>
        </StyledBadge>
      ) : (
        <StyledBadge
          className="defaultAvatarBadge"
          // overlap="circular"
          // anchorOrigin={{
          //   vertical: "bottom",
          //   horizontal: "right",
          // }}
          // variant="dot"
          sx={{
            marginBottom: marginBottom,
            top: top,
            left: left,
          }}
        >
          <Avatar
            onClick={onClick}
            alt={userName}
            title={userName}
            {...stringAvatar(userName)}
            className={className}
            sx={{
              minHeight: height,
              minWidth: width,
              height: height,
              width: width,
              backgroundColor: "black",
              fontSize: fontSize ? fontSize : "1rem",
              marginBottom: marginBottom,
              marginRight: marginRight,
              top: top,
              left: left,
            }}
          ></Avatar>
          {editor}
        </StyledBadge>
      )}
    </span>
  );
};

export default DefaultAvatar;
